import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../icon-button';
import { Popover, PopoverContent, PopoverTrigger } from '../popover';

const InfoWithPopover = ({ iconSize = 'small', title, content = null, ...popoverProps }) => (
  <div className="ws-ui-info-with-popover">
    <Popover placement="top-left" title={title} appearance="dark" {...popoverProps}>
      <PopoverTrigger>
        <div className="ws-ui-info-with-popover__icon">
          <IconButton glyph="info" size={iconSize} />
        </div>
      </PopoverTrigger>
      <PopoverContent>{content}</PopoverContent>
    </Popover>
  </div>
);

InfoWithPopover.propTypes = {
  title: PropTypes.node.isRequired,
  content: PropTypes.node,
  iconSize: PropTypes.string,
};

export default InfoWithPopover;
